<template>
    <section class="container step-indicator-container">
        <div class="step-indicator">
            <template v-for="(label, index) in labels" :key="index">
                <div class="step" :class="{ completed: current > index }">
                    <div class="step-circle"></div>
                    <p>{{ label }}</p>
                </div>
                <div v-if="index < labels.length - 1" class="line" :class="{ completed: current > index + 1 }"></div>
            </template>
        </div>
    </section>
</template>
<script setup lang="ts">
defineProps<{ current: number; labels: string[] }>();
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

/* Step Indicator */
.step-indicator-container {
    margin-bottom: 2rem;
}

.step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
}

.step-indicator .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
}

.step-indicator .step-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e0e0e0;
    border: 3px solid #ccc;
    transition: all 0.3s ease;
}

.step-indicator .step.completed .step-circle {
    background: $secondary-color;
    border-color: $secondary-color;
}

.step-indicator .step p {
    margin-top: 0.75rem;
    color: $primary-color;
    font-weight: 600;
    font-size: 0.85rem;
    text-align: center;
    max-width: 100px;
}

.step-indicator .line {
    width: 80px;
    height: 3px;
    background: #ccc;
    margin: 0 0.5rem;
    margin-bottom: 2rem;
    border-radius: 3px;
    transition: all 0.3s ease;
}

.step-indicator .line.completed {
    background: $secondary-color;
}
</style>